

















import { computed, defineComponent, PropType, useRoute } from '@nuxtjs/composition-api';
import { BaseList, BaseListItem } from '@shared/ui';
import sanitizeHtml from 'sanitize-html';

export default defineComponent({
  name: 'SearchBarPopularSearches',
  components: { BaseListItem, BaseList },
  props: {
    results: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const route = useRoute();
    const sanitizedResults = computed(() =>
      props.results.map((result) => ({
        ...result,
        label: sanitizeHtml(result.highlightResult, {
          allowedTags: ['em'],
        }),
      })),
    );

    const isActiveQuery = (path: string) => path === route.value.query['q'];

    const onClick = () => {
      emit('active-query-clicked');
    };

    return {
      sanitizedResults,
      isActiveQuery,
      onClick,
    };
  },
});
